module.exports = __webpack_public_path__ + "static/media/DS_Logo.c679133a.png";